<div class="card-title flex-space-between">
	<span translate>dashboard.card.time-in-stock</span>
</div>
<ng-container *ngIf="!isLoading else loading">
	<copo-bars class="time-in-stock" (barClicked)="linkTo($event)" [barData]="timeInStockGraphConfig"></copo-bars>
</ng-container>
<ng-template #loading>
	<copo-loading-spinner></copo-loading-spinner>
</ng-template>
<div class="card-block-footer mobile-hide">
	<button type="button" mat-button color="primary" (click)="viewDetails()">
		<span translate>dashboard.card.time-in-stock.view-details</span>
		<mat-icon iconPositionEnd color="accent" svgIcon="md:chevron_right"></mat-icon>
	</button>
</div>

